import React from "react";
import { locales } from "../../locales";

const Election = ({ data, evolutiveData, langId }) => {
  const { pollingStation } = data;
  const {
    percentageRegistered,
    totalApplicants,
    totalCandidates,
    totalForeignCandidates,
    municipalCouncil,
  } = evolutiveData;
  return (
    <div>
      <div className="bg-wort-background pt-9 pb-2">
        <h3 className="font-bold text-22 leading-[26.4px] text-center wort-medium:text-32 wort-medium:leading-38 wort-medium:pb-8">
          {locales[langId].electionInNumbers}
        </h3>
        <div className="grid grid-cols-3 wort-medium:grid-cols-6">
          <div className="w-108 h-90 flex items-center flex-col mt-5 border-r-2 wort-medium:w-184 wort-medium:h-100">
            <span className="text-36 leading-[45px] font-bold text-secondary wort-medium:text-5xl wort-medium:leading-10">
              {totalApplicants ? totalApplicants : "-"}
            </span>
            <span className="text-xs leading-ls text-center wort-medium:text-base wort-medium:leading-5 wort-medium:mt-[10px]">
              {locales[langId].candidates}¹
            </span>
          </div>
          <div className="w-108 h-90 flex items-center flex-col mt-5 border-r-2 wort-medium:w-184 wort-medium:h-100">
            <span className="text-36 leading-[45px] font-bold text-secondary wort-medium:text-5xl wort-medium:leading-10">
              {totalCandidates ? totalCandidates : "-"}
            </span>
            <span className="text-xs leading-ls text-center wort-medium:text-base wort-medium:leading-5 wort-medium:mt-[10px]">
              {locales[langId].candidatesWomen}¹
            </span>
          </div>
          <div className="w-108 h-90 flex items-center flex-col mt-5 wort-medium:w-184 wort-medium:border-r-2 wort-medium:h-100">
            <span className="text-36 leading-[45px] font-bold text-secondary wort-medium:text-5xl wort-medium:leading-10">
              {totalForeignCandidates ? totalForeignCandidates : "-"}
            </span>
            <span className="text-xs leading-ls text-center wort-medium:text-base wort-medium:leading-5 wort-medium:mt-[10px]">
              {locales[langId].candidatesForeigners}¹
            </span>
          </div>
          <div className="w-108 h-90 flex items-center flex-col mt-4 border-r-2 wort-medium:w-184 wort-medium:h-100">
            <span className="text-36 leading-[45px] font-bold text-secondary wort-medium:text-5xl wort-medium:leading-10">
              {pollingStation ? pollingStation : "-"}
            </span>
            <span className="text-xs leading-ls text-center wort-medium:text-base wort-medium:leading-5 wort-medium:mt-[10px]">
              {locales[langId].pollingStations}³
            </span>
          </div>
          <div className="w-108 h-90 flex items-center flex-col mt-4 border-r-2 wort-medium:w-184 wort-medium:h-100">
            <span className="text-36 leading-[45px] font-bold text-secondary wort-medium:text-5xl wort-medium:leading-10">
              {percentageRegistered
                ? percentageRegistered.toString().replace(".", ",") + " "
                : "-"}
            </span>
            <span className="text-xs leading-ls text-center wort-medium:text-[14px] wort-medium:leading-5 wort-medium:mt-[10px]">
              {locales[langId].pontetialVoters}²
            </span>
          </div>
          <div className="w-108 h-90 flex items-center flex-col mt-4 wort-medium:w-184 wort-medium:h-100">
            <span className="text-36 leading-[45px] font-bold text-secondary wort-medium:text-5xl wort-medium:leading-10">
              {municipalCouncil ? municipalCouncil : "-"}
            </span>
            <span className="text-xs leading-ls text-center wort-medium:text-base wort-medium:leading-5 wort-medium:mt-[10px]">
              {locales[langId].seatsToBeFilled}³
            </span>
          </div>
        </div>
        <p className="text-[10px] text-black-rgba mt-6 text-center px-8">
          [1]{locales[langId].references[0]} | [2]{" "}
          {locales[langId].references[1]} | [3] {locales[langId].references[2]}
        </p>
      </div>
    </div>
  );
};

export default Election;
